import { format, isToday, isYesterday } from "date-fns";
import { fr } from "date-fns/locale";

interface DateGroupHeaderProps {
  date: string;
}

export const DateGroupHeader = ({ date }: DateGroupHeaderProps) => {
  const dateObj = new Date(date);
  
  const getLabel = () => {
    if (isToday(dateObj)) return "Aujourd'hui";
    if (isYesterday(dateObj)) return "Hier";
    return format(dateObj, "EEEE d MMMM", { locale: fr });
  };

  return (
    <div className="sticky top-0 z-10 bg-background/95 backdrop-blur-sm py-2 px-3 mb-2 border-b">
      <h2 className="text-sm font-semibold text-foreground">
        {getLabel()}
      </h2>
    </div>
  );
};
